module.exports = __webpack_public_path__ + "img/stamp.0a9195d1.png";